import React from 'react'
import { Link } from 'react-router-dom'
import { socialLinks } from '../common/socialLinks'
import VideoContainer from '../common/aboutYoutubeVideo'

const Footer = ({ language }) => {

    const textContent = {
        en: {
            UsefulLinks:'Useful Links',
            Booking:'Booking',
            Exploremuseum:'Explore museum',
            Blogs:'Blogs',
            ContactUs:'Contact Us',
            GiveFeedback:'Give Feedback',
            HelpSupport:'Help & Support',
            Address:'Address',
            AddressDetail:'Mahabharat Museum, Jyotisar. Kurukshetr. (Haryana)',
            FollowUs:'Follow Us',
        },
        hi: {
            UsefulLinks:'उपयोगी लिंक',
            Booking:'बुकिंग',
            Exploremuseum:'संग्रहालय देखें ',
            Blogs:'ब्लॉग',
            ContactUs:'संपर्क करें',
            GiveFeedback:'प्रतिक्रिया दें ',
            HelpSupport:'सहायता एवं समर्थन',
            Address:'पता',
            AddressDetail:'महाभारत संग्रहालय, ज्योतिसर। कुरुक्षेत्र। (हरियाणा)',
            FollowUs:'हमें फ़ॉलो करें',
        },
      };

    return (
        <div className="footer-section">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-lg-4">
                        <div className="footer-about">
                            <Link to="#" className="footer-logo"><img src="/images/footer-logo.png" alt="" /></Link>
                            <Link to="#" className="footer-logo"><img src="/images/haryana-tourism-logo.png" alt="" /></Link>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="Useful-Links">
                            <h4>{textContent[language].UsefulLinks}</h4>
                            <ul>
                                <li><Link to="http://Jyotisar.haryanatourism.co.in">{textContent[language].Booking}</Link></li>
                                <li><Link to="/gallery">{textContent[language].Exploremuseum}</Link></li>
                                <li><Link to="/blogs">{textContent[language].Blogs}</Link></li>
                                <li><Link to="/contact-us">{textContent[language].ContactUs}</Link></li>
                                <li><Link to="/feedback">{textContent[language].GiveFeedback}</Link></li>
                                <li><Link to="/help">{textContent[language].HelpSupport}</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="address">
                            <h3>{textContent[language].Address}</h3>
                            <address>
                                {textContent[language].AddressDetail}
                            </address>
                            <br />
                            <h4>{textContent[language].FollowUs}</h4>
                            <ul>
                                <li><Link to={"javascript:void(0)"} ><img src="/images/facebook.svg" alt="" /></Link></li>
                                <li><Link to={"javascript:void(0)"} ><img src="/images/youtube.svg" alt="" /></Link></li>
                                <li><Link to={"javascript:void(0)"} ><img src="/images/instagram.svg" alt="" /></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="copyright-text">
                        All rights reserved <Link to="#">Mahabharat Museum.</Link>
                    </div>
                </div>
            </div>
            {/* <div className='audio_guide'>
                <Link to="https://itihasa.net.in/" className='audio_guide_link' target='_blank'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play-icon lucide-play"><path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"/></svg></Link>
            </div> */}
        </div>
    )
}

export default Footer